<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span class="">{{ total }} Utilisateur<span v-if="total > 1">s</span></span>
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          v-if="canAddUsers"
          class="page-header-btn is-small is-secondary is-widthFixToHeaderAccount"
          :to="{name: 'UserCreate'}">
          <!--<span class="icon is-medium"><i class="fas fa-plus-circle"></i></span>-->
          <span>Créer utilisateur</span>
        </router-link>
      </template>
    </page-nav-bar>

    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          :loading="loading"
          @opened="openedCol = !openedCol"
          @resetFilters="resetFilters()">
          <div class="is-padding">
            <div class="field">
              <div class="control">
                <input
                  id="name-user-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.searchable_name"
                  class="input"
                  type="text"
                  placeholder="Nom / Prénom">
              </div>
            </div>
            <div class="field">
              <div class="control">
                <input
                  id="email-user-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.email"
                  class="input"
                  type="text"
                  placeholder="email">
              </div>
            </div>
            <div class="field">
              <label class="label">Profils</label>
            </div>
            <div
              class="field"
              v-for="(profil, index) in profils"
              :key="index">
              <input
                class="is-checkradio is-squareCheck"
                :id="profil.label"
                type="checkbox"
                name="profil"
                :value="profil"
                @click="updateSimpleFilter"
                v-model="filters.profil">
              <label :for="profil.label">{{ profil.label | cap }}</label>
            </div>
          </div>
        </col-collapse-filter>
      </template>

      <div class="is-border">
        <div class="row-width-actions-bar is-border-bottom">
          <div class="columns is-gapless">
            <transition
              enter-active-class="animated fadeIn fasterx2"
              leave-active-class="animated fadeOut fasterx2"
              mode="out-in">
              <div
                class="column is-narrow has-background-primary has-text-white is-flex"
                v-if="hasFilter">
                <div
                  class="is-self-centered is-padding-left is-padding-right"
                  :data-count="count">
                  Résultat : {{ count }} utilisateur(s)
                </div>
              </div>
            </transition>
          </div>
        </div>
        <filters-tags
          id="user-tag"
          :has-filter="hasFilter"
          :filters="filters"
          @reset="resetFilters"
          @update="beforeUpdateFromTag($event)"></filters-tags>
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>
        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="true">
          <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium has-actionsontd">
            <thead class="has-cells-vcentered">
              <tr class="is-size-6">
                <th
                  class="is-paddingless has-text-centered"
                  style="z-index:2;">
                  <columns-toggles
                    :entries="columnsList"
                    :source="columns"
                    @update="updateColumns"
                    :default-colums-width="''"></columns-toggles>
                </th>
                <th>
                  <sortable
                    sort-id="last_name"
                    @sort="sort('last_name', $event)"
                    :sort="sortBy.last_name"
                    label="Nom"></sortable>
                </th>
                <th>
                  <sortable
                    sort-id="first_name"
                    @sort="sort('first_name', $event)"
                    :sort="sortBy.first_name"
                    label="Prénom"></sortable>
                </th>
                <th>
                  Profil
                </th>
                <th>
                  <sortable
                    sort-id="email"
                    @sort="sort('email', $event)"
                    :sort="sortBy.email"
                    label="Email"></sortable>
                </th>
                <th v-if="showColumn('phone')">
                  Téléphone
                </th>
                <th>
                  Statut
                </th>
                <th class="has-text-centered"></th>
              </tr>
            </thead>
            <tbody class="has-cells-vcentered">
              <tr
                v-for="(user, i) in items"
                :key="user.pk"
                class="is-size-6"
                :id="'e' + user.pk"
                :class="{'has-status-bar--left has-status-bar--draft': lastOpenedItemPk === user.pk}">
                <td class="is-cell-hoverable has-text-centered">
                  <router-link
                    :to="{name: 'UserVue', params: {id: user.pk}}"
                    class="is-inline-flex">
                    <avatar
                      :item="user"
                      :i="i"></avatar>
                  </router-link>
                </td>
                <td class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'UserVue', params: {id: user.pk}}"
                    class="fullLink">
                    {{ user.last_name }}
                  </router-link>
                </td>
                <td class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'UserVue', params: {id: user.pk}}"
                    class="fullLink">
                    {{ user.first_name }}
                  </router-link>
                </td>
                <td v-if="user.first_admin">
                  Admin (Référent)
                </td>
                <td v-else>
                  {{ user.profil | profilTypeLabel }}
                </td>
                <td class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'UserVue', params: {id: user.pk}}"
                    class="fullLink">
                    {{ user.email }}
                  </router-link>
                </td>
                <td v-if="showColumn('phone')">
                  <phone-number
                    v-if="user.phone"
                    :phone="user.phone"></phone-number>
                  <span v-else>
                    -
                  </span>
                </td>
                <td>
                  <div
                    style="cursor: pointer; height:100%; width: 100%"
                    v-if="user.locked"
                    class="is-flex-center">
                    <span
                      class="tooltip is-tooltip-left is-flex-center"
                      :data-tooltip="'Compte Désactivé'">
                      <i
                        class="fas fa-circle"
                        style="color: red; font-size: 18px; opacity: 0.7"></i>
                    </span>
                  </div>
                  <div
                    style="cursor: pointer; height:100%; width: 100%"
                    class=" is-flex-center"
                    v-else>
                    <span
                      class="tooltip is-tooltip-left is-flex-center"
                      :data-tooltip="'Compte Actif'">
                      <i
                        class="fas fa-circle"
                        style="color: green; font-size: 18px; opacity: 0.7"></i>
                    </span>
                  </div>
                </td>
                <td class="has-text-centered">
                  <display-button-list
                    :buttons="buttonList"
                    :data="user"
                    :hide-text-when-solo="true">
                  </display-button-list>
                </td>
              </tr>
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucun utilisateur disponible
            </h2>
            <a
              class="has-text-primary"
              @click="resetFilters"
              v-if="hasFilter"><span class="icon"><i class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
          </div>
        </div>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event)"></pagination>
      </div>
    </page-content>
  </div>
</template>

<script>
import moment from 'moment'
import { uniq, cloneDeep } from 'lodash'
import { USER_PROFIL_CHOICES } from '@batimentb/vadimm-js-commons/values'
import { GenericList, Filter, Sort, DefaultValues, ColumnConf, User, FilterGetter } from '@/mixins'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'UserList',
  mixins: [GenericList, Filter, Sort, DefaultValues, ColumnConf, User, FilterGetter],
  data () {
    return {
      deleteTitle: 'Suppression utilisateur',
      deleteText: `L'utilisateur ne pourra plus se connecter et vous ne pourrez plus lui assigner d'actions et de contacts. La fiche de l'utilisateur ne sera plus consultable.`,
      profils: Object.values(USER_PROFIL_CHOICES),
      columnsConfResource: 'users',
      buttonList: [
        {
          action: id => {
            let actionId = id
            this.$router.push({ name: 'UserVue', params: { id: actionId } })
          },
          icon: 'fa-address-card',
          text: 'Fiche utilisateur'
        },
        {
          action: id => {
            let actionId = id
            this.$router.push({ name: 'UserEdit', params: { id: actionId } })
          },
          icon: 'fa-user-edit',
          text: 'Modifier fiche utilisateur',
          needProfile: ['admin', 'manager'],
          display: user => {
            if (this.currentUser.profil === 'manager') {
              if (user && user.manager) {
                return user.manager.pk === this.currentUser.pk
              }
            } else if (this.currentUser.profil === 'admin') {
              return !user.first_admin
            }
          }
        },
        {
          action: (id, user) => {
            this.inviteUser(user)
          },
          icon: 'fa-paper-plane',
          text: 'Envoyer invitation',
          needProfile: ['admin', 'manager'],
          display: user => user.pk !== this.currentUserPk
        },
        {
          action: (id, user) => {
            if (user) {
              if (user.locked || !user.locked) {
                this.updateStatusUser(user)
              }
            }
          },
          icon: 'fa-user-slash',
          text: 'Désactiver le compte',
          needProfile: ['admin'],
          display: user => {
            if (!user.locked && !user.first_admin) {
              if (user.pk !== this.currentUserPk) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          }
        },
        {
          action: (id, user) => {
            if (user) {
              if (user.locked || !user.locked) {
                this.updateStatusUser(user)
              }
            }
          },
          icon: 'fa-eye reactive',
          text: 'Réactiver le compte',
          needProfile: ['admin'],
          display: user => {
            if (user.locked && !user.first_admin) {
              if (user.pk !== this.currentUserPk) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          }
        }
        // {
        //   action: id => {
        //     let actionId = id
        //     this.deleteItem(actionId)
        //   },
        //   icon: 'fa-trash-alt',
        //   text: 'Supprimer utilisateur',
        //   display: user => {
        //     if (this.currentUser.profil === 'manager') {
        //       if (user && user.manager) {
        //         return user.manager.pk === this.currentUser.pk
        //       }
        //     } else if (this.currentUser.profil === 'admin') {
        //       return user.pk !== this.currentUserPk && !user.first_admin
        //     }
        //   }
        // }
      ],
      loadDocuments: this.loadItems,
      filters: {
        account: null,
        email: null,
        searchable_name: null,
        profil: []
      },
      initFilters: {
        account: null,
        email: null,
        searchable_name: null,
        profil: []
      },
      service: 'USER',
      openedCol: false
    }
  },
  computed: {
    ...mapGetters(['currentUserPk', 'lastOpenedItemPk', 'canAddUsers']),
    ...mapState({
      savedFilters: 'savedFilters',
      currentUser: 'currentUser',
      accountsList: 'accounts'
    }),
    today () {
      return moment()
    },
    columnsShow () {
      let columns = {
        'phone': { label: 'Téléphone', mobile: false }
      }
      return columns
    }
  },
  created () {
    this.accounts = this.accountsList.slice()
    if ('userList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    }
  },
  methods: {
    checkCanModify (v) {
      console.log('v =>', v)
    },
    /**
      * function to user before an update from tag component
      * updateFromTag in FilterMixin.js
      * @param event - event to update
      */
    beforeUpdateFromTag (event) {
      let updatedEvent = event
      if (updatedEvent.profil === null) {
        updatedEvent.profil = []
      }
      this.updateFromTag(updatedEvent)
    },
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.userList)
      this.updateSimpleFilter()
    },
    /**
      * function to user before load items
      * prepare query
      * loadItems in GenericListMixin.js
      */
    beforeGet () {
      if (this.query.account) {
        this.query.account = this.query.account.pk || this.query.account
      }
      if (Array.isArray(this.query.profil) && this.query.profil.length) {
        this.query.profil = uniq(this.query.profil.map(x => x.value || x))
      }
      for (let key in this.filters) {
        this.$store.commit('setSavedFilters', { from: 'userList', name: key, value: this.filters[key] })
      }
    },
    async updateStatusUser (user) {
      if (user.locked === false) {
        this.$swal({
          title: 'Désactiver le compte',
          text: 'Ce compte utilisateur sera désactivé, son accès à Vadimm sera restreint jusqu\'à sa réactivation. Les options, ventes et contacts liés à ce compte ne seront pas impactés.',
          confirmButtonText: 'Désactiver',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-danger'
          }
        }).then(async value => {
          if (value && value.dismiss) {
          } else if (value) {
            try {
              user.locked = !user.locked
              await this.$api.patch(this.$resources.USER, user.pk, user)
              this.$toasted.global.success('Compte user désactiver')
            } catch (e) {
              this.$toasted.global.danger('Erreur lors de la désactivation !')
            }
          }
        })
      } else if (user.locked === true) {
        this.$swal({
          title: 'Réactiver le compte',
          text: 'Ce compte sera réactivé. L\'utilisateur pourra à nouveau se connecter à Vadimm. Êtes-vous sûr de vouloir réactiver ce compte ?',
          confirmButtonText: 'Réactiver',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-success'
          }
        }).then(async value => {
          if (value && value.dismiss) {
          } else if (value) {
            try {
              user.locked = !user.locked
              await this.$api.patch(this.$resources.USER, user.pk, user)
              this.$toasted.global.success('Compte user désactiver')
            } catch (e) {
              this.$toasted.global.danger('Erreur lors de la désactivation !')
            }
          }
        })
      }
    }
  }
}
</script>
